import { Banner } from "@components/commerce/categories/banner";
import { CategoryNavigation } from "@components/ui/category-navigation/CategoryNavigation";
import type { ILink, ILinksCollection } from "@contentful-api/types/contentful";
import { resolveMediaAsset } from "@lib/contentful/api/helpers/resolveMediaAsset";
import { Box } from "@ecco/ui/box";
import type { FC } from "react";

interface SubNavigationProps {
    linksCollection?: ILinksCollection;
}

export const SubNavigation: FC<SubNavigationProps> = ({ linksCollection }) => {
    const links = linksCollection?.fields?.links ?? [];
    const hasLinkImages = links.some((item) => {
        const linkFields = (item as ILink)?.fields;
        return resolveMediaAsset(linkFields?.linkAsset, linkFields?.linkImage);
    });

    if (!hasLinkImages) {
        return <CategoryNavigation items={linksCollection} />;
    }

    return (
        <Box ml={[3, 3, 7, 6]}>
            <Banner bannerItems={links} />
        </Box>
    );
};
